<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフ一覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <div class="admin_top_wrap">
            <div class="admin_top_box">
                <h1>スタッフ/ニュース管理</h1>
                <div class="admin_top_btns">
                    <ul>
                        <li>
                            <router-link class="admin_top_btn" to="/ubiadmin/AdminStaffList">
                                スタッフ<br>一覧
                                <img src="../assets/img/admin_top_img1.png">
                            </router-link>
                        </li>
                        <li>
                            <router-link class="admin_top_btn" to="/ubiadmin/AdminNewsList">
                                ニュース<br>一覧/編集
                                <img src="../assets/img/admin_top_img2.png">
                            </router-link>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <router-link class="admin_top_btn" to="/ubiadmin/AdminStaffEdit">
                                スタッフ<br>登録
                                <img src="../assets/img/admin_top_img3.png">
                            </router-link>
                        </li>
                        <li>
                            <router-link class="admin_top_btn" to="/ubiadmin/AdminNewsEdit">
                                ニュース<br>登録
                                <img src="../assets/img/admin_top_img4.png">
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        logout() {
            this.$store.commit('reset');
            this.$router.push({name:'aLogin'});
        }
    }
}
</script>

<style scoped>

.admin_top_wrap {
    width: 100vw;
    height: 93vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
}

.admin_top_box {
    width: 80vw;
}

.admin_top_btns {
    width: 70vw;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    padding: 30px 80px;
}

.admin_top_btns li {
    position: relative;
}

.admin_top_btns img {
    position: absolute;
    bottom: 10px;
    left: 10px;
}

h1 {
    margin-bottom: 20px;
}

ul {
    width: 100%;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-around;
}

ul:nth-child(2) {
    margin-bottom: 0;
}

li {
    width: 35%;
}

a.admin_top_btn {
    display: block;
    text-decoration: none;
    background-color: #4DC0AD;
    color: #fff;
    text-align: right;
    width: 100%;
    height: 150px;
    padding: 20px 10px 10px 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/AdminTop.vue